import type { MathJaxConfig } from '../../types/mathjax';

// Static MathJax configuration
export const MATHJAX_CONFIG: MathJaxConfig = {
  chtml: {
    displayAlign: 'left',
    displayIndent: '0em',
    matchFontHeight: false,
    minScale: 0.5,
    scale: 1.2,
  },
  options: {
    enableMenu: false,
    ignoreHtmlClass: 'no-math',
    processHtmlClass: 'math-content',
    skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre'],
  },
  startup: {
    pageReady: () => {
      return window.MathJax?.startup?.defaultPageReady?.() || Promise.resolve();
    },
    ready: () => {
      const startup = window.MathJax?.startup;
      if (startup?.defaultReady) {
        startup.defaultReady();
      }
      window.__MATHJAX_READY__ = true;
      window.dispatchEvent(new Event('mathjax-ready'));
    },
  },
  svg: {
    fontCache: 'global',
    minScale: 0.5,
    scale: 1.2,
  },
  tex: {
    displayMath: [
      ['$$', '$$'],
      ['\\[', '\\]'],
    ],
    inlineMath: [
      ['$', '$'],
      ['\\(', '\\)'],
    ],
    processEnvironments: true,
    processEscapes: true,
    processRefs: true,
  },
};